<template>

    <v-container class="grey darken-3 pb-0 pl-0 pr-0">
        <v-row no-gutters>

            <v-col lg="3" md="4" cols="12" v-if="errorCount===0">
                <icon-box icon="mdi-check" icon-color="green">
                    No errors found!
                </icon-box>
            </v-col>

            <v-col lg="3" md="4" cols="12" v-if="errorCount > 0 && !replaceWithNull">
                <icon-box icon="mdi-alert" icon-color="red" :clickable="true" @click="showErrors(errorMessages)">
                    {{ errorCount }} value(s) will fail validation!
                </icon-box>
            </v-col>

            <v-col lg="3" md="4" cols="12" v-if="replaceWithNull">
                <icon-box icon="mdi-alert" icon-color="red" :clickable="true" @click="showErrors(errorMessages)">
                    {{ errorCount }} value(s) will be replaced with null!
                </icon-box>
            </v-col>

            <v-col lg="3" md="4" cols="12" v-if="possibleTypes.length > 1 && !replaceWithNull">
                <icon-box icon="mdi-information" icon-color="yellow">
                    Warning multiple types found! ({{ possibleTypes.join(', ')}})
                </icon-box>
            </v-col>

            <v-col lg="3" md="4" cols="12" v-if="autoMapped">
                <icon-box icon="mdi-check" icon-color="green">
                    Automatically mapped
                </icon-box>
            </v-col>

            <v-col lg="3" md="4" cols="12" v-if="bestType">
                <icon-box icon="mdi-information-outline" icon-color="green">
                    Detected type: {{ bestType }}
                </icon-box>
            </v-col>

            <v-col lg="3" md="4" cols="12" v-if="valuePercent">

                <icon-box v-show="valuePercent<100" icon="mdi-information" icon-color="yellow">
                    {{ valuePercent }}% of rows contain value
                </icon-box>

                <icon-box v-show="valuePercent===100" icon="mdi-check" icon-color="green">
                    {{ valuePercent }}% of rows contain value
                </icon-box>

            </v-col>

            <v-col lg="3" md="4" cols="12">
                <icon-box icon="mdi-information-outline" icon-color="green">
                    Value count: {{ valueCount }}
                </icon-box>
            </v-col>

        </v-row>

        <error-dialog
                v-if="showErrorDialog"
                :data="errorDialogData"
                @close="showErrorDialog=false"
        ></error-dialog>

    </v-container>

</template>

<script>
    import ErrorDialog from './ErrorDialog.vue';
    import IconBox from '../../../components/UI/IconBox'

    export default {

        props: {
            valueCount: {
                type: Number,
                required: true,
            },
            errorCount: {
                type: Number,
                required: true
            },
            autoMapped: {
                type: Boolean,
                required: true,
            },
            errorMessages: {
                type: Array,
                required: true
            },
            nullCount: {
                type: Number,
                required: true,
            },
            valuePercent: {
                type: Number,
                required: true,
            },
            bestType: {
                type: String | null,
                required: true,
            },
            possibleTypes: {
                type: Array,
                required: true,
            },
            replaceWithNull: {
                type: Boolean,
                required: true,
            }
        },

        components: {
            ErrorDialog,
            IconBox
        },

        data() {
            return {
                show: true,
                showErrorDialog: false,
                errorDialogData: null,
            }
        },
        methods: {
            showErrors(errors) {
                this.errorDialogData = errors;
                this.showErrorDialog = true;
            },
        }
    }

</script>

